import { useState } from 'react';
import { getAppEnvironment } from '@/shared/lib/runtimeEnvironment';
import { Button } from '@/shared/ui/Button/Button';
import s from './DeleteAccountButton.module.scss';
import Trash from '@/shared/assets/icons/trash.svg';
import { DeleteAccountModal } from '../DeleteAccountModal/DeleteAccountModal';
import { GeneralSelectedI } from '@/shared/model/types/generalSelected';
import { IconButton } from '@/shared/ui/IconButton/IconButton';
import { useScreenDetector } from '@/shared/lib/hooks/useScreenDetector';
import { hasNonActiveSelection } from '@/shared/lib/utils/accountPresentation';

interface DeleteAccountButtonProps extends GeneralSelectedI {
  isIcon?: boolean;
  resetSelectedRows?: () => void;
  mode?: 'account' | 'club';
  deletionType?: 'lifecycle' | 'hard';
  disabled?: boolean;
}

export const DeleteAccountButton = (props: DeleteAccountButtonProps) => {
  const {
    arrayOfName,
    arrayOfId,
    accountStatuses,
    isIcon,
    resetSelectedRows,
    mode = 'account',
    deletionType = 'lifecycle',
    disabled = false,
  } = props;
  const isLifecycleDisabled = !isIcon && hasNonActiveSelection(accountStatuses);
  const isDisabled = disabled || isLifecycleDisabled;
  const isHardDelete = mode === 'account' && deletionType === 'hard';
  const iconColor = mode === 'account' && !isHardDelete && getAppEnvironment() === 'dev' ? 'yellow' : 'red';
  const [open, setOpen] = useState(false);
  const { isMobile } = useScreenDetector();

  return (
    <>
      {isIcon ? (
        <IconButton
          size={isMobile ? 'xs' : 'm'}
          color={iconColor}
          onClick={() => setOpen(true)}
          disabled={isDisabled}
          title={isHardDelete ? 'Удалить навсегда' : 'Удалить'}
        >
          <Trash />
        </IconButton>
      ) : (
        <Button
          onClick={() => setOpen(true)}
          color={'red'}
          width={'fill'}
          size={'xs'}
          disabled={isDisabled}
          title={isLifecycleDisabled ? 'Выберите только активные сущности' : undefined}
        >
          <div className={s.buttonContent}>
            <span>{isHardDelete ? 'Удалить навсегда' : 'Удалить'}</span>
            <Trash className={s.icon} />
          </div>
        </Button>
      )}

      {open && (
        <DeleteAccountModal
          arrayOfName={arrayOfName}
          arrayOfId={arrayOfId}
          open={open}
          onClose={() => setOpen(false)}
          resetSelectedRows={resetSelectedRows}
          mode={mode}
          deletionType={deletionType}
          accountStatuses={accountStatuses}
        />
      )}
    </>
  );
};
